import getConfig from 'next/config'

export const SENTRY_CONFIG = {
  dsn: process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0.06,
  normalizeDepth: 5,
  ignoreUrls: [/app:\/\/\/inpage\.js/],
  ignoreErrors: [
    'Non-Error promise rejection captured',
    'Non-Error exception captured',
    "Cannot read properties of undefined (reading 'firefoxSample')",
    'Loading chunk 996 failed. (error: https://static.zdassets.com/ekr/sentry-browser.min.js)',
    /^(?=.*\bAttempt to use history\.replaceState\(\) more than 100 times per (10|30) seconds\b).*$/gm,
  ],
  beforeBreadcrumb(breadcrumb, hint) {
    const baseUrl = getConfig().publicRuntimeConfig.baseAPIClientUrl
    const regExp = new RegExp(`^${baseUrl}/`)

    if (
      breadcrumb.category === 'xhr' &&
      regExp.test(breadcrumb?.data?.url) &&
      hint
    ) {
      return null
    }

    return breadcrumb
  },
}
